import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=63e767b2&scoped=true"
import script from "./shop.js?vue&type=script&lang=js&external"
export * from "./shop.js?vue&type=script&lang=js&external"
import style0 from "./shop.scss?vue&type=style&index=0&id=63e767b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e767b2",
  null
  
)

export default component.exports